import React, { useEffect, useState } from 'react';
import {
  Table,
  Card,
  Button,
  Tag,
  Typography,
  Space,
  Row,
  Col,
  message
} from 'antd';
import {
  Plus,
  Pencil,
  User,
  Rocket,
  History,
  Briefcase
} from 'lucide-react';
import { getAssistantPlans } from "../../../services/assistant-plan";
import AdminLayout from "../../../components/admin-layout";
import { Link, useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;

export default function AssistantPlansList() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const fetchPlans = async () => {
    setLoading(true);
    try {
      const response = await getAssistantPlans({});
      const plans = Array.isArray(response) ? response : (response.data || []);
      setData(plans);
    } catch (error) {
      console.error(error);
      message.error("Falha ao carregar planos");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPlans();
  }, []);

  const formatCurrency = (value) => {
    return value?.toLocaleString("pt-br", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 2,
    });
  };

  const formatNumber = (value) => value?.toLocaleString('pt-BR');

  const columns = [
    {
      title: "Nome",
      dataIndex: "name",
      key: "name",
      render: (text) => <Text strong>{text}</Text>,
    },
    {
      title: "Tipo",
      dataIndex: "type",
      key: "type",
      render: (type) => (
        <Tag color={type === "pack" ? "purple" : "blue"} style={{ borderRadius: 12, paddingLeft: 10, paddingRight: 10 }}>
          {type === "pack" ? "PACOTE" : "POR USO"}
        </Tag>
      ),
    },
    {
      title: "Preço",
      dataIndex: "price",
      key: "price",
      render: (val) => (
        <Space>
          <Text type="success" strong>{formatCurrency(val)}</Text>
          <Text type="secondary" style={{ fontSize: 12 }}>/mês</Text>
        </Space>
      )
    },
    {
      title: "Limites",
      key: "limits",
      render: (_, record) => (
        <Space size="middle">
          <Space size={4} title="Requisições">
            <Rocket size={14} style={{ color: '#8c8c8c' }} />
            <Text style={{ fontSize: 13 }}>{record.maxRequests === -1 ? '∞' : formatNumber(record.maxRequests)}</Text>
          </Space>
          <Space size={4} title="Assistentes">
            <User size={14} style={{ color: '#8c8c8c' }} />
            <Text style={{ fontSize: 13 }}>{formatNumber(record.maxAssistants)}</Text>
          </Space>
          <Space size={4} title="Histórico">
            <History size={14} style={{ color: '#8c8c8c' }} />
            <Text style={{ fontSize: 13 }}>{formatNumber(record.maxLogSize)}</Text>
          </Space>
        </Space>
      )
    },
    {
      title: "Unitário (Msg / Sessão)",
      key: "costs",
      render: (_, record) => (
        <Space split={<Text type="secondary">|</Text>}>
          <Text style={{ fontSize: 13 }}>{formatCurrency(record.pricePerMessage)}</Text>
          <Text style={{ fontSize: 13 }}>{formatCurrency(record.pricePerSession)}</Text>
        </Space>
      )
    },
    {
      title: "",
      key: "actions",
      width: 50,
      render: (_, record) => (
        <Button
          type="text"
          icon={<Pencil size={16} />}
          onClick={() => navigate(`${record.id}`)}
        />
      ),
    },
  ];

  return (
    <AdminLayout withBackground={false}>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          {/* Header Area matching Dashboard-New style */}
          <Row justify="space-between" align="middle">
            <Col>
              <Space style={{ marginRight: 6, marginBottom: 16, marginTop: 16 }}>
                <Briefcase size={14} style={{ marginTop: "4px" }} />
                <Typography.Title style={{ padding: 0, margin: 0 }} level={5} strong>
                  Planos de Assistentes
                </Typography.Title>
              </Space>
            </Col>
            <Col>
              <Link to="create">
                <Button type="primary" icon={<Plus size={16} />} style={{ borderRadius: 6 }}>
                  Novo Plano
                </Button>
              </Link>
            </Col>
          </Row>
        </Col>

        <Col span={24}>
          <Card size="small" bodyStyle={{ padding: 0 }}>
            <Table
              loading={loading}
              columns={columns}
              dataSource={data}
              rowKey="id"
              pagination={{ pageSize: 10, hideOnSinglePage: true }}
              scroll={{ x: 800 }}
            />
          </Card>
        </Col>
      </Row>
    </AdminLayout>
  );
}
